import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import StudyOverviewView from '../overview/StudyOverviewView';
import StudyOverviewTabState from './StudyOverviewTabState';

export default class StudyOverviewTabView extends BufferTabView<StudyOverviewTabState> {
  reactRoot: ReactDOM.Root | null = null;

  static override initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override initialize(): void {
    this.listenTo(this.model, 'change', () => this.render());
  }

  override render(): this {
    const id = this.model.get('studyId');
    // Accepts either a procedure run id or a procedure run plan id as runId
    const runOrPlanId = this.model.get('runId');
    this.reactRoot = renderToDOM(
      <StudyOverviewView id={id} runOrPlanId={runOrPlanId} />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

StudyOverviewTabView.initClass();
